class AuthToken {
    constructor() {
        this.init();
    }

    init() {
        this.id_token = '';
        this.access_token = '';
        this.refresh_token = '';
        this.email = '';
        this.name = '';
        this.relationship = undefined;
        this.groups = undefined;
        this.admin = undefined;
        this.provider_id = undefined;
        this.admin_unit = undefined;
        this.parent_id = undefined;
        this.navigator_id = undefined;
        this.user_id = undefined;
        this.legup_list_id = undefined;
        this.roles = undefined;
        this.pages = undefined;
    }

    copy() {
        const cp = new AuthToken();
        cp.id_token = this.id_token;
        cp.access_token = this.access_token;
        cp.refresh_token = this.refresh_token;
        cp.email = this.email;
        cp.name = this.name;
        cp.relationship = this.relationship;
        cp.groups = this.groups;
        cp.admin = this.admin;
        cp.provider_id = this.provider_id;
        cp.admin_unit = this.admin_unit;
        cp.parent_id = this.parent_id;
        cp.navigator_id = this.navigator_id;
        cp.user_id = this.user_id;
        cp.legup_list_id = this.legup_list_id;
        cp.roles = this.roles ? [].concat(this.roles) : undefined;
        cp.pages = this.pages ? [].concat(this.pages) : undefined;
        return cp;
    }

    buildFromJSON(obj) {
        this.init();
        if (obj) {
            this.id_token = obj.id_token ? obj.id_token : '';
            this.access_token = obj.access_token ? obj.access_token : '';
            this.refresh_token = obj.refresh_token? obj.refresh_token: '';
            this.email = obj.email ? obj.email : '';
            this.name = obj.name? obj.name: '';
            this.relationship = obj.relationship;
            this.groups= obj.groups;
            this.admin = (obj.admin === undefined) || (obj.admin === null)
              ? undefined : obj.admin;
            this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
            this.admin_unit = (obj.admin_unit === undefined) || (obj.admin_unit === null)
              ? undefined : obj.admin_unit;
            this.parent_id = obj.parent_id ? obj.parent_id.toString() : undefined;
            this.navigator_id = obj.navigator_id ? obj.navigator_id.toString() : undefined;
            this.user_id = obj.user_id ? obj.user_id.toString() : undefined;
            this.legup_list_id = obj.legup_list_id ? obj.legup_list_id.toString() : undefined;
            this.pages = obj.pages ? [].concat(obj.pages) : undefined;
            this.roles = obj.roles ? [].concat(obj.roles) : undefined;
        }
    }

    getIdToken() {
        return this.id_token;
    }

    setIdToken(id_token) {
        this.id_token = id_token;
    }

    getAccessToken() {
        return this.access_token;
    }

    setAccessToken(access_token) {
        this.access_token = access_token;
    }

    getRefreshToken() {
        return this.refresh_token;
    }

    setRefreshToken(refresh_token) {
        this.refresh_token = refresh_token;
    }

    getEmail() {
        return this.email;
    }

    setEmail(email) {
        this.email = email;
    }

    getName() {
        return this.name;
    }

    setName(name) {
        this.name = name;
    }

    getRelationship() {
      return this.relationship;
    }

    setRelationship(relationship) {
      this.relationship = relationship;
    }
    
    getGroups() {
        return this.groups;
    }

    setGroups(groups) {
      this.groups = groups;
    }

    getIsAdmin() {
        return this.admin;
    }

    setIsAdmin(admin) {
        this.admin = admin;
    }

    getProviderId() {
        return this.provider_id;
    }
    
    setProviderId(provider_id) {
        this.provider_id = provider_id;
    }

    getIsAdminUnit() {
      return this.admin_unit;
    }

    setIsAdminUnit(admin_unit) {
      this.admin_unit = admin_unit;
    }
    
    getParentId() {
        return this.parent_id;
    }

    setParentId(parent_id) {
        this.parent_id = parent_id;
    }

    getNavigatorId() {
        return this.navigator_id;
    }

    setNavigatorId(navigator_id) {
        this.navigator_id = navigator_id;
    }

    getUserId() {
        return this.user_id;
    }

    setUserId(user_id) {
        this.user_id = user_id;
    }

    getMarketId() {
        return this.legup_list_id;
    }

    setMarketId(legup_list_id) {
        this.legup_list_id = legup_list_id;
    }

    getPages() {
        return this.pages || [];
    }

    setPages(pages) {
        this.pages = pages ? [].concat(pages) : undefined;
    }

    getRoles() {
        return this.roles || [];
    }

    setRoles(roles) {
        this.roles = roles ? [].concat(roles) : undefined;
    }
}

module.exports = AuthToken;
